import axios, { AxiosError, AxiosResponse } from 'axios';

export default async function uploadFileWithFormData (formData: FormData, fileType: string) {
  return await 
    axios
      .post(
        '/upload_file/',
        formData,
        {
          headers: {
            'Content-Type': fileType,
          },
        },
      )
      .then(
        (res: AxiosResponse) => {
          if (res.data.status !== 'OK') {
            console.error(`Could not upload file due to error: ${res.data.message}`);
            return false;
          } else {
            return res.data.url;
          }
        },
        (err: AxiosError) => {
          console.error(`Could not upload file due to error: ${err}.`);
          return false;
        },
      );
}
